import { getUrl } from '../bibe'
import { CALLBACKS_PRODUCTION_URL, OIDC_AUTHORIZE_PATH } from './constants'

export function getOidcAuthorizeUrl(returnUrl: string): string {
  const url = new URL(OIDC_AUTHORIZE_PATH, getUrl(CALLBACKS_PRODUCTION_URL))
  url.searchParams.set('return_url', returnUrl)
  return url.href
}
